// Routes that own the whole screen while the visitor completes a handoff —
// /redeem, and the MCP consent/upgrade round-trip back to Claude at /connect.
// Interrupting either with NUX or a congratulations modal risks stranding them
// mid-flow, so both are suppressed and shown on the next ordinary visit.
export const FOCUSED_PATHS = ['/redeem', '/connect'];

/**
 * Whether the current location is one of those handoffs. A campaign page with a
 * promo code (/for/:slug?code=…) is the /redeem flow on a custom homepage, and is
 * focused for exactly as long as the code is in the URL — promo.jsx strips it
 * once it can redeem, and the landing page strips it when the flow is declined.
 */
export const isFocusedFlow = (pathname, search = '') =>
  FOCUSED_PATHS.includes(pathname) ||
  (pathname.startsWith('/for/') && new URLSearchParams(search).has('code'));
